<template>
  <div id="filter-welcome-bg" :style="{backgroundImage: bgPhoto}" role="region">
    <div id="video-banner-overlay">
      <video v-if="images.videoLink.length > 0" autoplay="true" class="hidden-xs" id="homepage-background-video" loop="true" muted="true">
        <source class="ajax-video" :src="images.videoLink" type="video/mp4">
      </video>
    </div>
    <div class="hero-overlay"></div>
    <div class="container content-container">
      <h2 class="text-center" id="call-to-action-overlay">Welcome to Auto Dealer</h2>
      <div class="search-box">
        <ul class="list-unstyled options row nav-tabs text-center" role="tablist">
          <li class="col-xs-4 active" role="presentation">
            <a aria-controls="shop-new" class="btn option-btn" data="true" data-toggle="tab" href="#shop-new" role="tab" value="new">New</a>
            <div class="a-underline"></div>
          </li>
          <li class="col-xs-4" role="presentation">
            <a aria-controls="shop-used" class="btn option-btn" data="false" data-toggle="tab" href="#shop-used" role="tab" value="used">Used</a>
            <div class="a-underline"></div>
          </li>
          <li class="col-xs-4" role="presentation">
            <a aria-controls="shop-price" class="btn option-btn" data-toggle="tab" href="#shop-price" role="tab">By Price</a>
            <div class="a-underline"></div>
          </li>
        </ul>
        <div class="tools row tab-content">
          <div class="tab-pane active" id="shop-new" role="tabpanel">
            <div class="vehicle-browse-ajax">
              <form action="/vehicles" class="vehicle-search-form" method="get">
                <input class="inventory-type set-on-load" name="new" type="hidden" value="true">
                <select class="hidden form-control vehicle-search search-inv-type" name="type">
                  <option data="true" value="new">New</option>
                  <option data="false" value="used">Used</option>
                </select>
                <div class="form-group col-md-3 col-xs-12">
                  <select class="form-control vehicle-search vehicle-search-make" name="make">
                    <option value="default">{{brandName}}</option>
                  </select>
                </div>
                <div class="form-group col-md-3 col-xs-12">
                  <select class="form-control vehicle-search vehicle-search-model" name="model">
                    <option value="default">Model</option>
                  </select>
                </div>
                <div class="form-group col-md-3 col-xs-12">
                  <select class="form-control vehicle-search vehicle-search-year" name="year">
                    <option value="default">Year</option>
                  </select>
                </div>
                <div class="form-group col-md-3 col-xs-12">
                  <input class="vehicle-search-submit btn btn-block find-my-car-button" type="submit" value="Search">
                  </div>
              </form>
            </div>
          </div>
          <div class="tab-pane" id="shop-used" role="tabpanel">
            <div class="vehicle-browse-ajax">
              <form class="vehicle-search-form">
                <input class="inventory-type set-on-load" name="used" type="hidden"
                  value="false">
                <select class="hidden form-control vehicle-search search-inv-type" name="type">
                  <option data="false" value="new">New</option>
                  <option data="true" value="used">Used</option>
                </select>
                <div class="form-group col-md-3 col-xs-12">
                  <select class="form-control vehicle-search vehicle-search-make" name="make">
                    <option value="default">Make</option>
                  </select>
                </div>
                <div class="form-group col-md-3 col-xs-12">
                  <select class="form-control vehicle-search vehicle-search-model" name="model">
                    <option value="default">Model</option>
                  </select>
                </div>
                <div class="form-group col-md-3 col-xs-12">
                  <select class="form-control vehicle-search vehicle-search-year" name="year">
                    <option value="default">Year</option>
                  </select>
                </div>
                <div class="form-group col-md-3 col-xs-12"><input
                    class="vehicle-search-submit btn btn-block find-my-car-button" type="submit" value="Search"></div>
              </form>
            </div>
          </div>
          <div class="tab-pane price-range-search search-section" id="shop-price" role="tabpanel">
            <form class="price-range">
              <div class="form-group col-md-4 col-xs-12"><select class="form-control vehicle-search vehicle-search-min"
                  name="min">
                  <option hidden="">Minimum</option>
                  <option value="0">0</option>
                  <option value="5000">5,000</option>
                  <option value="10000">10,000</option>
                  <option value="15000">15,000</option>
                  <option value="20000">20,000</option>
                  <option value="30000">30,000</option>
                  <option value="40000">40,000</option>
                  <option value="50000">50,000</option>
                </select></div>
              <div class="form-group col-md-4 col-xs-12"><select class="form-control vehicle-search vehicle-search-max"
                  name="max">
                  <option hidden="">Maximum</option>
                  <option value="10000">10,000</option>
                  <option value="15000">15,000</option>
                  <option value="20000">20,000</option>
                  <option value="30000">30,000</option>
                  <option value="40000">40,000</option>
                  <option value="50000">50,000</option>
                  <option value="75000">75,000</option>
                  <option value="100000">100,000</option>
                  <option value="150000">150,000</option>
                  <option value="200000">200,000</option>
                </select></div>
            </form>
            <div class="form-group col-md-4 col-xs-12">
              <a class="btn btn-block price-range-btn" href="#" type="submit">Search</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    bgPhoto () {
      if (this.brand !== 'honda') {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
#filter-welcome-bg {
    height: 80vh;
    min-height: 600px;
    max-height: 1000px;
    margin: auto;
    padding: 20px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    font-family: 'Helvetica Neue', Arial, sans-serif;
}
#filter-welcome-bg .content-container {
    z-index: 5;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
#filter-welcome-bg .hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background-color: rgba(0, 0, 0, 0.3);
}
#call-to-action-overlay {
    color: #fff;
    margin-bottom: 50px;
    font-size: 35px;
    font-weight: 400;
    z-index: 2;
}
video#homepage-background-video {
    position: absolute;
    top: -18%;
    left: 0;
    min-width: 100%;
    min-height: 118%;
    width: auto;
    height: auto;
    z-index: 0;
    background-size: cover;
}
#filter-welcome-bg form {
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    z-index: 2;
}
#filter-welcome-bg .nav-tabs {
    padding: 10px 0;
}
#filter-welcome-bg .nav-tabs li, #filter-welcome-bg .options a, #filter-welcome-bg .nav-tabs {
    border: none;
    background: transparent !important;
}
#filter-welcome-bg .tab-pane {
    padding-top: 15px;
}
#filter-welcome-bg .search-box {
    background: rgba(0,0,0,.7);
    padding: 10px;
    z-index: 2;
    color: #fff;
}
#filter-welcome-bg .options a {
    color: #fff;
    font-size: 18px;
}
#filter-welcome-bg .vehicle-search-submit, #filter-welcome-bg .price-range-btn {
    background: var(--primary-color);
    border: 2px solid #fff;
    color: #fff;
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 400;
    padding: 8px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
}
#filter-welcome-bg .vehicle-search-submit:hover, #filter-welcome-bg .vehicle-search-submit:active, #filter-welcome-bg .vehicle-search-submit:focus, #filter-welcome-bg .price-range-btn:hover, #filter-welcome-bg .price-range-btn:active, #filter-welcome-bg .price-range-btn:focus {
    background: #fff;
    color: var(--primary-color);
}
#filter-welcome-bg .form-control, #filter-welcome-bg .form-control:focus {
    background: transparent;
    color: #fff;
    border: none;
    box-shadow: none;
}
#filter-welcome-bg .tab-pane .form-group:after {
    content: ' ';
    width: 0;
    height: 0px;
    display: inline-block;
    border: 4px solid transparent;
    border-top-color: #fff;
    position: absolute;
    right: 3px;
    top: 17px;
}
#filter-welcome-bg .tab-pane .form-group:last-of-type:after {
  border: 0px solid transparent;
  border-top-color: transparent;
}
#filter-welcome-bg .tab-pane.price-range-search form .form-group:last-of-type:after {
  border: 4px solid transparent;
  border-top-color: #fff;
}
#filter-welcome-bg ul.options:after {
    content: "";
    height: 2px;
    width: 90%;
    background-color: #fff;
    opacity: .3;
    margin: auto;
    position: relative;
    top: 15px;
}
#shop-price select {
    width: 100%;
}

@media(min-width: 768px) {
    #filter-welcome-bg .search-box {
        padding-bottom: 15px;
        min-height: 175px;
    }
    #filter-welcome-bg .a-underline {
        content: "";
        height: 2px;
        width: 70%;
        background: #fff;
        margin: auto;
        position: absolute;
        left: 15%;
        bottom: -16px;
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        transition: all .5s ease;
        opacity: 0;
    }
    #filter-welcome-bg .active .a-underline {
        opacity: 1;
    }
}

@media (max-width: 991px) {
  #filter-welcome-bg .tab-pane .form-group:after {
    right: 30px;
  }
}

@media(max-width: 768px) {
    #call-to-action-overlay {
        font-size: 30px;
    }
    #filter-welcome-bg .options, #filter-welcome-bg .tools {
        margin: auto;
    }
    #filter-welcome-bg .content-container {
        padding: 0;
        margin: auto;
    }
    #filter-welcome-bg .nav-tabs li {
        padding-right: 0;
        padding-left: 0;
    }
    #filter-welcome-bg .nav-tabs li a {
        font-size: 16px;
    }
}
</style>